import React, { Component } from 'react'
import { HorizontalBar } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import NoData from './noData'

class TxStatusesComplete extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartData: {},
      noData: false,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { props } = this
    if (prevProps.data !== this.props.data) {
      if (props.data && props.data.transaction_data) {
        const { data } = props
        if (data.transaction_data) {
          const { complete, failed, restarted } = data.transaction_data

          const labels = ['Approved', 'Declined', 'Restarted']

          const chartData = {
            labels,
            datasets: [
              {
                label: 'Transactions Closed',
                data: [complete, failed, restarted],
                backgroundColor: ['#6ac9a3', '#6ca8c1', '#8d9096', 'teal'],
                hoverBackgroundColor: ['#6ac9a3', '#6ca8c1', '#8d9096', 'teal'],
              },
            ],
          }
          if ([complete, failed, restarted].filter((i) => i).length === 0) {
            this.setState({ noData: true })
          } else {
            this.setState({ noData: false })
            this.setState({ chartData })
          }
        }
      }
    }
  }

  render() {
    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <h5>
            Transactions Closed For&nbsp;
            {this.props.timeSpan}
          </h5>
        </div>
        {this.state.noData && <NoData />}
        {!this.state.noData && (
          <div className='ibox-content' style={{ display: 'flex', height: 350 }}>
            <HorizontalBar
              data={this.state.chartData}
              options={{
                maintainAspectRatio: false,
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  data: state.allMetrics.results,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxStatusesComplete))
